/**
 * LOS MARCADORES DE POSICIÓN QUE PONE EL ADAPTADOR.
 *
 * Cuando entra una foto por WhatsApp, el mensaje llega con `[Imagen]` como
 * contenido. Eso no es un pie de foto que escribió nadie: es un relleno para
 * que el mensaje tenga texto. Si se pinta tal cual, la burbuja enseña la foto
 * y debajo la palabra «[Imagen]», que no aporta nada y parece un fallo.
 *
 * ═══ POR QUÉ ESTO NO VIVE EN `MedioDelMensaje.tsx` ═══
 *
 * Un archivo que exporta un componente Y una función rompe el fast refresh de
 * Vite: al tocar el componente, React recarga la pantalla entera en vez de solo
 * esa parte, y se pierde el scroll del chat. El lint lo avisa, y corre con
 * `--max-warnings 0`, así que ese aviso tenía la puerta en rojo.
 */

const MARCADORES = new Set([
  '[Imagen]',
  '[Video]',
  '[Audio]',
  '[Nota de voz]',
  '[Sticker]',
  '[Documento]',
  '[Ubicación]',
  '[Ubicacion]',
]);

export function esSoloMarcador(contenido: string): boolean {
  return MARCADORES.has(contenido.trim());
}
